var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$q.platform.is.mobile
    ? _c(
        "q-layout-drawer",
        {
          attrs: { side: "left" },
          model: {
            value: _vm.openMenu,
            callback: function($$v) {
              _vm.openMenu = $$v
            },
            expression: "openMenu"
          }
        },
        [
          _c(
            "q-list",
            { attrs: { "no-border": "", link: "", "inset-separator": "" } },
            [
              _c("q-list-header", [_vm._v(_vm._s(_vm.$t("navigation")))]),
              _c(
                "q-item",
                { attrs: { to: { name: "admin_overview" } } },
                [
                  _c("q-item-side", {
                    attrs: { icon: "far fa-tachometer-alt-slowest" }
                  }),
                  _c("q-item-main", { attrs: { label: "Visão Geral" } })
                ],
                1
              ),
              _vm.showUsers ||
              _vm.showOrganization ||
              _vm.showTags ||
              _vm.showTablePoints ||
              _vm.showImport
                ? _c(
                    "q-collapsible",
                    {
                      attrs: {
                        icon: "far fa-book",
                        label: _vm.$t("registrations"),
                        group: "navigation"
                      }
                    },
                    [
                      _c(
                        "q-list",
                        { attrs: { link: "", separator: "" } },
                        [
                          _vm._l(_vm.users, function(content, index) {
                            return _vm.showMenu(content.meta) && _vm.showUsers
                              ? _c(
                                  "q-item",
                                  {
                                    key: "ru" + index,
                                    attrs: { to: { name: content.to } }
                                  },
                                  [
                                    _c("q-item-side", {
                                      attrs: { icon: content.icon }
                                    }),
                                    _c("q-item-main", {
                                      attrs: { label: _vm.$t(content.text) }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          }),
                          _vm._l(_vm.organization, function(content, index) {
                            return _vm.showMenu(content.meta) &&
                              _vm.showOrganization
                              ? _c(
                                  "q-item",
                                  {
                                    key: "ro" + index,
                                    attrs: { to: { name: content.to } }
                                  },
                                  [
                                    _c("q-item-side", {
                                      attrs: { icon: content.icon }
                                    }),
                                    _c("q-item-main", {
                                      attrs: { label: _vm.$t(content.text) }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          }),
                          _vm._l(_vm.tags, function(content, index) {
                            return _vm.showMenu(content.meta) && _vm.showTags
                              ? _c(
                                  "q-item",
                                  {
                                    key: "tt" + index,
                                    attrs: { to: { name: content.to } }
                                  },
                                  [
                                    _c("q-item-side", {
                                      attrs: { icon: content.icon }
                                    }),
                                    _c("q-item-main", {
                                      attrs: { label: _vm.$t(content.text) }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          }),
                          _vm._l(_vm.points_table, function(content, index) {
                            return _vm.showMenu(content.meta) &&
                              _vm.showTablePoints
                              ? _c(
                                  "q-item",
                                  {
                                    key: "tablep" + index,
                                    attrs: { to: { name: content.to } }
                                  },
                                  [
                                    _c("q-item-side", {
                                      attrs: { icon: content.icon }
                                    }),
                                    _c("q-item-main", {
                                      attrs: { label: _vm.$t(content.text) }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          }),
                          _vm._l(_vm.importUser, function(content, index) {
                            return _vm.showMenu(content.meta) && _vm.showImport
                              ? _c(
                                  "q-item",
                                  {
                                    key: "imp" + index,
                                    attrs: { to: { name: content.to } }
                                  },
                                  [
                                    _c("q-item-side", {
                                      attrs: { icon: content.icon }
                                    }),
                                    _c("q-item-main", {
                                      attrs: { label: _vm.$t(content.text) }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          })
                        ],
                        2
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showSurveys ||
              _vm.showMessages ||
              _vm.showFaq ||
              _vm.showBanners ||
              _vm.showCalendar
                ? _c(
                    "q-collapsible",
                    {
                      attrs: {
                        icon: "far fa-volume-up",
                        label: _vm.$t("communications"),
                        group: "navigation"
                      }
                    },
                    [
                      _c(
                        "q-list",
                        { attrs: { link: "", separator: "" } },
                        [
                          _vm._l(_vm.surveys, function(content, index) {
                            return _vm.showMenu(content.meta) && _vm.showSurveys
                              ? _c(
                                  "q-item",
                                  {
                                    key: "cs" + index,
                                    attrs: { to: { name: content.to } }
                                  },
                                  [
                                    _c("q-item-side", {
                                      attrs: { icon: content.icon }
                                    }),
                                    _c("q-item-main", {
                                      attrs: { label: _vm.$t(content.text) }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          }),
                          _vm._l(_vm.messages, function(content, index) {
                            return _vm.showMenu(content.meta) &&
                              _vm.showMessages
                              ? _c(
                                  "q-item",
                                  {
                                    key: "cm" + index,
                                    attrs: { to: { name: content.to } }
                                  },
                                  [
                                    _c("q-item-side", {
                                      attrs: { icon: content.icon }
                                    }),
                                    _c("q-item-main", {
                                      attrs: { label: _vm.$t(content.text) }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          }),
                          _vm._l(_vm.faq, function(content, index) {
                            return _vm.showMenu(content.meta) && _vm.showFaq
                              ? _c(
                                  "q-item",
                                  {
                                    key: "cf" + index,
                                    attrs: { to: { name: content.to } }
                                  },
                                  [
                                    _c("q-item-side", {
                                      attrs: { icon: content.icon }
                                    }),
                                    _c("q-item-main", {
                                      attrs: { label: _vm.$t(content.text) }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          }),
                          _vm._l(_vm.banners, function(content, index) {
                            return _vm.showMenu(content.meta) && _vm.showBanners
                              ? _c(
                                  "q-item",
                                  {
                                    key: "cb" + index,
                                    attrs: { to: { name: content.to } }
                                  },
                                  [
                                    _c("q-item-side", {
                                      attrs: { icon: content.icon }
                                    }),
                                    _c("q-item-main", {
                                      attrs: { label: _vm.$t(content.text) }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          }),
                          _vm._l(_vm.calendar, function(content, index) {
                            return _vm.showMenu(content.meta) &&
                              _vm.showCalendar
                              ? _c(
                                  "q-item",
                                  {
                                    key: "cc" + index,
                                    attrs: { to: { name: content.to } }
                                  },
                                  [
                                    _c("q-item-side", {
                                      attrs: { icon: content.icon }
                                    }),
                                    _c("q-item-main", {
                                      attrs: { label: _vm.$t(content.text) }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          })
                        ],
                        2
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showRewards
                ? _c(
                    "q-collapsible",
                    {
                      attrs: {
                        icon: "far fa-trophy",
                        label: _vm.$t("rewards"),
                        group: "navigation"
                      }
                    },
                    [
                      _c(
                        "q-list",
                        { attrs: { link: "", separator: "" } },
                        _vm._l(_vm.rewards, function(content, index) {
                          return _vm.showMenu(content.meta) && _vm.showRewards
                            ? _c(
                                "q-item",
                                {
                                  key: "rr" + index,
                                  attrs: { to: { name: content.to } }
                                },
                                [
                                  _c("q-item-side", {
                                    attrs: { icon: content.icon }
                                  }),
                                  _c("q-item-main", {
                                    attrs: { label: _vm.$t(content.text) }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "q-list",
            { attrs: { "no-border": "", link: "", "inset-separator": "" } },
            [
              _c("q-list-header", [_vm._v(_vm._s(_vm.$t("others")))]),
              _c(
                "q-item",
                {
                  nativeOn: {
                    click: function($event) {
                      return _vm.goToHome()
                    }
                  }
                },
                [
                  _c("q-item-side", { attrs: { icon: "far fa-home" } }),
                  _c("q-item-main", { attrs: { label: _vm.$t("home") } })
                ],
                1
              ),
              _vm.user_clients.length > 1
                ? _c(
                    "q-collapsible",
                    {
                      attrs: {
                        icon: "far fa-building",
                        label: _vm.getClientLabel,
                        group: "sidebar"
                      },
                      model: {
                        value: _vm.show_clients,
                        callback: function($$v) {
                          _vm.show_clients = $$v
                        },
                        expression: "show_clients"
                      }
                    },
                    [
                      _c(
                        "q-list",
                        { attrs: { separator: "", link: "" } },
                        _vm._l(_vm.user_clients, function(item, index) {
                          return _c(
                            "q-item",
                            { key: index, attrs: { tag: "label" } },
                            [
                              _c(
                                "q-item-side",
                                [
                                  _c("q-radio", {
                                    attrs: { val: item.id },
                                    model: {
                                      value: _vm.selected_client,
                                      callback: function($$v) {
                                        _vm.selected_client = $$v
                                      },
                                      expression: "selected_client"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "q-item-main",
                                [
                                  _c("q-item-tile", { attrs: { label: "" } }, [
                                    _vm._v(_vm._s(item.name))
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.user_clients.length == 1
                ? _c(
                    "q-item",
                    [
                      _c("q-item-side", { attrs: { icon: "far fa-building" } }),
                      _c("q-item-main", {
                        attrs: { label: _vm.getClientLabel }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.countries.length > 1
                ? _c(
                    "q-collapsible",
                    {
                      attrs: {
                        icon: "far fa-globe",
                        label: _vm.getCountryLabel,
                        group: "sidebar"
                      },
                      model: {
                        value: _vm.show_countries,
                        callback: function($$v) {
                          _vm.show_countries = $$v
                        },
                        expression: "show_countries"
                      }
                    },
                    [
                      _c(
                        "q-list",
                        { attrs: { separator: "", link: "" } },
                        _vm._l(_vm.countries, function(item, index) {
                          return _c(
                            "q-item",
                            { key: index, attrs: { tag: "label" } },
                            [
                              _c(
                                "q-item-side",
                                [
                                  _c("q-radio", {
                                    attrs: { val: item.id },
                                    model: {
                                      value: _vm.selected_country,
                                      callback: function($$v) {
                                        _vm.selected_country = $$v
                                      },
                                      expression: "selected_country"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "q-item-main",
                                [
                                  _c("q-item-tile", { attrs: { label: "" } }, [
                                    _vm._v(_vm._s(item.name))
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.countries.length == 1
                ? _c(
                    "q-item",
                    [
                      _c("q-item-side", { attrs: { icon: "far fa-globe" } }),
                      _c("q-item-main", {
                        attrs: { label: _vm.getCountryLabel }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.reward_selection_campaigns.length > 0
                ? _c(
                    "q-collapsible",
                    {
                      attrs: {
                        icon: "far fa-award",
                        label: _vm.$t(_vm.getCampaignLabel),
                        group: "sidebar"
                      },
                      model: {
                        value: _vm.show_campaigns,
                        callback: function($$v) {
                          _vm.show_campaigns = $$v
                        },
                        expression: "show_campaigns"
                      }
                    },
                    [
                      _c(
                        "q-list",
                        { attrs: { separator: "", link: "" } },
                        _vm._l(_vm.campaignsList, function(item, index) {
                          return _c(
                            "q-item",
                            { key: index, attrs: { tag: "label" } },
                            [
                              _c(
                                "q-item-side",
                                [
                                  _c("q-radio", {
                                    attrs: { val: item.value },
                                    model: {
                                      value: _vm.selected_campaign,
                                      callback: function($$v) {
                                        _vm.selected_campaign = $$v
                                      },
                                      expression: "selected_campaign"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "q-item-main",
                                [
                                  _c("q-item-tile", { attrs: { label: "" } }, [
                                    _vm._v(_vm._s(item.title))
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "q-collapsible",
                {
                  attrs: {
                    icon: "far fa-user-circle",
                    label: _vm.full_name,
                    group: "sidebar"
                  }
                },
                [
                  _c(
                    "q-list",
                    { attrs: { separator: "", link: "" } },
                    [
                      _c(
                        "q-item",
                        {
                          nativeOn: {
                            click: function($event) {
                              return _vm.logout()
                            }
                          }
                        },
                        [
                          _c(
                            "q-item-side",
                            [
                              _c("q-icon", {
                                attrs: { name: "far fa-sign-out-alt" }
                              })
                            ],
                            1
                          ),
                          _c(
                            "q-item-main",
                            [
                              _c("q-item-tile", { attrs: { label: "" } }, [
                                _vm._v(_vm._s(_vm.$t("sign_out")))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("copyright")
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }